<template>
  <div>
    <div class="centerx">
      <vs-popup
        fullscreen
        title="Termo de cessão de imagem"
        :active.sync="popupActivo4"
      >
        <div>
          <fullAgeTerm
            v-if="this.participantAge > this.minAge"
            :data="this.getFormData()"
          />
          <underageTerm v-else :data="this.getFormData()" />
        </div>
        <vs-checkbox
          v-model="form.imageAssignment"
          name="imageAssignment"
          data-vv-as="'de aceite do Termo de Cessão de Imagem'"
          class="mt-8"
          @change="jumpFromImageAssignmentToPhotoEdit()"
        >
          Li e concordo com o Termo de Cessão de Imagem
        </vs-checkbox>
      </vs-popup>
    </div>

    <div
      id="participant-form"
      class="h-screen flex vx-row no-gutter items-center justify-center"
    >
      <!-- confirm SMS modal -->
      <vs-prompt
        id="sms-modal"
        class="active-sms-modal"
        title="Identificação por SMS ou e-mail"
        accept-text="Confirmar"
        cancel-text="Cancelar"
        :active.sync="activeSMSModal"
        @accept="sendSMSCodeAndConfirm"
      >
        <div class="sms-form">
          <p class="wizard-text text-center">
            Enviamos um código para o número:
            <br />
            <b>{{ participantMobile | formatCelphoneMasked }}</b>
            <br />
          </p>

          <p class="wizard-text text-center" style="margin-top: 5px">
            e no e-mail:
            <br />
            <b>{{ participantEmail }}</b>
          </p>
          <p class="wizard-text text-center" style="margin-top: 16px">
            Informe abaixo o código recebido
          </p>
          <vs-row vs-w="12" class="sms-number-holder pr-6 pl-6 mt-2">
            <vs-col
              v-for="$index in [0, 1, 2, 3]"
              :key="$index"
              vs-type="flex"
              vs-justify="left"
              vs-align="center"
              vs-w="3"
              class="p-2"
            >
              <vs-input
                v-model="smsCode[$index]"
                type="tel"
                class
                :id="'SMS-Code' + $index"
                :name="'SMS-Code' + $index"
                v-mask="'#'"
                @keypress="validateInput($event)"
                @keydown.delete="returToInput($event)"
                @focus="
                  ($event) => {
                    $event.target.select();
                    setInputIndex($index);
                  }
                "
                @paste.prevent="handlePasteValue"
                data-vv-as="'SMS-Code'"
                v-validate="'required|min:1|max:9'"
                :ref="`smsInput${$index}`"
              />
            </vs-col>
          </vs-row>
          <span
            class="text-danger text-sm text-center w-full"
            id="cpf-error"
            v-show="smsCodeErrorMsg"
            >{{ smsCodeErrorMsg }}</span
          >
        </div>
      </vs-prompt>
      <!-- confirm SMS modal -->

      <div
        class="h-screen w-full vx-col sm:w-1/2 md:w-1/2 sm:m-0"
        :class="[
          'wizard-step-' + tabIndex,
          {
            'wizard-finished': operationWasSuccessfull,
            'no-padding': [0, 3].includes(tabIndex),
          },
        ]"
      >
        <form-wizard
          scope="FormWizardScope"
          ref="formWizard"
          @on-change="handlePageChanges"
          :startIndex="startIndex"
          :title="''"
          :subtitle="''"
          :color="'#7367F0'"
          id="form"
        >
          <template slot="footer" slot-scope="FormWizardScope" v-show="false">
            <div class="wizard-footer-left" v-show="false" />
            <div class="wizard-footer-right" v-show="false" />
          </template>

          <tab-content :before-change="beforeTabChange0">
            <img
              src="@/assets/images/pages/login/sbt-caravanas-logo.png"
              alt="Portal do Auditório e Inscrições do SBT"
              class="mx-auto sbt-logo"
            />
            <h3 class="wizard-title">
              Bem vindo(a) ao Portal do Auditório e Inscrições do SBT.
            </h3>
            <p class="wizard-text" style="margin-top: 30px">
              Nesse portal você poderá se inscrever para participar das
              caravanas produzidas pelo
              <b class="name">{{ caravanistName }}.</b>
            </p>
            <p class="wizard-text">
              Antes de Continuar,
              <b>tenha em mãos seu RG e CPF.</b>
            </p>
            <vs-row vs-justify="center" style="margin: 40px 0">
              <vs-button @click="startFlow()" style="border-radius: 24px"
                >Clique aqui para começar</vs-button
              >
            </vs-row>
          </tab-content>

          <tab-content :before-change="beforeTabChange1">
            <div v-if="isCpfOk === true">
              <vs-input
                label="CPF"
                v-model="form.cpf"
                type="tel"
                class="mt-3 w-full"
                id="cpf"
                name="cpf"
                v-mask="'###.###.###-##'"
                data-vv-as="'CPF'"
                v-validate="'required|cpf'"
              />
              <span
                class="text-danger text-sm"
                id="cpf-error"
                v-show="errors.has('cpf')"
                >{{ errors.first("cpf") }}</span
              >
              <vs-input
                label="Data de nascimento"
                v-model="form.birthdate"
                type="tel"
                class="mt-3 w-full"
                id="birthdate"
                name="birthdate"
                v-mask="'##/##/####'"
                data-vv-as="'Data de nascimento'"
                v-validate="
                  `required|date_format:dd/MM/yyyy|date_between:01/01/1910,${today}`
                "
              />
              <span
                class="text-danger text-sm"
                id="birthdate-error"
                v-show="errors.has('birthdate')"
                >{{ errors.first("birthdate") }}</span
              >
              <div class="row-navigation-2-buttons">
                <vs-button class="back-button" @click="goToWelcome()"
                  ><i class="fa fa-arrow-left"></i>Voltar</vs-button
                >
                <vs-button @click="checkCpfOnServer()" class="next-button">
                  <span v-if="cpfStepButtonText && cpfStepButtonText.length > 0"
                    ><i
                      class="fas fa-circle-notch fa-spin"
                      style="color: #fff; font-size: 15px; margin-right: 10px"
                    ></i>
                    {{ cpfStepButtonText }}
                  </span>
                  <span v-if="!cpfStepButtonText"> Avançar </span>
                  <i class="fa fa-circle-arrow-right"></i
                ></vs-button>
              </div>
            </div>
            <div v-else>
              <h2 style="margin: 20px 0">
                Desculpe, tivemos um problema com sua conta.
              </h2>
              <p>
                No momento não será possível continuar com sua inscrição. Por
                favor, entre em contato com a Caravanista ou com a equipe de
                Auditório e Inscrições do SBT.
              </p>
            </div>
          </tab-content>
          <tab-content :before-change="beforeTabChange2">
            <div v-if="!isNewUser && !isNewAssociation && isInResumeMode">
              <resume
                v-show="true"
                :data="{ participantData, caravanist }"
                @goToPhoto="jumpFromResumeToPhoto()"
              />
              <div class="row-navigation-2-buttons">
                <vs-button
                  class="back-button"
                  @click="jumpFromDataOkToSuccess()"
                  ><i class="fa fa-thumbs-up"></i>Dados OK</vs-button
                >
                <vs-button
                  @click="jumpFromResumeToUserForm()"
                  class="next-button"
                  >Atualizar Dados</vs-button
                >
              </div>
            </div>
            <div v-else-if="isNewAssociation">
              <div class="new-association-container">
                <p>Você já está cadastrado com outro(a) Caravanista</p>
                <div style="margin-top: 30px">
                  <h5>
                    Deseja se associar com a nova caravanista
                    <b style="color: blue">{{ caravanistName }}</b> ?
                  </h5>
                </div>
                <vs-row vs-justify="center" style="margin: 40px 0">
                  <vs-button
                    @click="createAssociation()"
                    style="border-radius: 24px"
                  >
                    <span v-if="isCreatingAssociation">
                      <i
                        class="fas fa-circle-notch fa-spin"
                        style="color: #fff; font-size: 15px; margin-right: 10px"
                      ></i>
                      Aguarde...
                    </span>
                    <span v-else>
                      <b>Sim.</b> Associar com esta caravanista
                    </span>
                  </vs-button>
                </vs-row>
              </div>
            </div>
            <div v-else>
              <div v-show="participantAge < minAge" style="margin-top: 10px">
                <div class="image-girl-container">
                  <img
                    :src="require('../../assets/images/portrait/girl.png')"
                    width="80px"
                  />
                </div>
                <p class="wizard-text">
                  Dados do <b>participante</b> (menor de idade):
                </p>
              </div>

              <vs-input
                label="Nome Completo"
                v-model="form.name"
                placeholder="Ex.: Maria Aparecida"
                type="text"
                class="w-full"
                id="name"
                name="name"
                data-vv-as="'Nome com sobrenome'"
                v-validate="{
                  required: true,
                  min: 5,
                  max: 255,
                  regex: /^[a-zÀ-ú]+(?:\s[a-zÀ-ú]+)+\s*$/i,
                }"
              />
              <span
                class="text-danger text-sm"
                id="name-error"
                v-show="errors.has('name')"
                >{{ errors.first("name") }}</span
              >

              <p style="margin-top: 10px; font-size: 12px">Gênero</p>
              <select
                class="mt-5 w-full"
                name="gender"
                id="gender"
                v-model="form.gender"
                @change="onGenderChange"
              >
                <option value="">Selecione</option>
                <option value="feminine">Feminino</option>
                <option value="male">Masculino</option>
                <option value="others">Outro</option>
              </select>
              <span
                class="text-danger text-sm"
                id="specialNeed-error"
                v-show="genderError"
              >
                O campo 'Gênero' é obrigatório
              </span>
              <!--  -->
              <div v-if="showGenderDetails">
                <vs-input
                  label="Qual gênero você se identifica?"
                  v-model="form.genderDetails"
                  type="text"
                  class="mt-3 w-full"
                  id="genderDetails"
                  name="genderDetails"
                  data-vv-as="'Gênero'"
                  v-validate="{
                    required: false,
                    max: 255,
                  }"
                />
                <vs-input
                  label="Nome Social para Travesti ou Transexual"
                  v-model="form.selfRefer"
                  type="text"
                  class="mt-3 w-full"
                  id="selfRefer"
                  name="selfRefer"
                  data-vv-as="'Nome Social para Travesti ou Transexual'"
                  v-validate="{
                    required: false,
                    max: 255,
                  }"
                />
              </div>
              <!--  -->
              <p style="margin-top: 10px; font-size: 12px">
                Possui alguma necessidade especial?
              </p>
              <select
                class="w-full"
                name="specialNeeds"
                id="specialNeeds"
                @change="onNeedsChange($event)"
              >
                <option value="">Selecione</option>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </select>
              <span
                class="text-danger text-sm"
                id="specialNeed-error"
                v-show="specialNeedError"
              >
                O campo 'Necessidade especial' é obrigatório
              </span>

              <vs-textarea
                v-if="form.specialNeeds === '1'"
                class="mt-3 w-full normal"
                label="Descreva suas necessidades especials"
                id="specialNeed"
                name="specialNeed"
                v-model="form.specialNeed"
                data-vv-as="'Necessidades Especiais'"
              />
              <span
                class="text-danger text-sm"
                id="specialNeed-error"
                v-show="1 === 1"
                >{{ errors.first("specialNeed") }}</span
              >

              <div
                v-show="participantAge < minAge"
                style="margin-top: 20px; margin-bottom: 5px"
              >
                <div class="image-adult-container">
                  <img
                    class="image-adult-man"
                    :src="require('../../assets/images/portrait/man.png')"
                  />
                  <img
                    class="image-adult-woman"
                    :src="require('../../assets/images/portrait/woman.png')"
                  />
                </div>

                <p class="wizard-text">
                  Dados do <b>adulto responsável</b> pelo participante:
                </p>
              </div>
              <div v-show="participantAge >= minAge">
                <vs-input
                  label="RG"
                  v-model="form.rg"
                  maxlength="14"
                  type="text"
                  class="mt-3 w-full"
                  id="rg"
                  name="rg"
                  data-vv-as="'RG'"
                  v-validate="'required|min:7|max:14'"
                />
                <span
                  class="text-danger text-sm"
                  id="rg-error"
                  v-show="errors.has('rg')"
                  >{{ errors.first("rg") }}</span
                >

                <vs-input
                  label="Celular (usado para confirmar sms)"
                  v-model="form.mobile"
                  type="tel"
                  class="mt-3 w-full"
                  id="mobile"
                  name="mobile"
                  v-mask="'(##) #####-####'"
                  data-vv-as="'Celular'"
                  v-validate="'required|min:15|max:15'"
                />
                <span
                  class="text-danger text-sm"
                  id="mobile-error"
                  v-show="errors.has('mobile')"
                  >{{ errors.first("mobile") }}</span
                >

                <vs-input
                  label="E-mail"
                  v-model="form.email"
                  type="email"
                  class="mt-3 w-full"
                  id="email"
                  name="email"
                  data-vv-as="'E-mail'"
                  v-validate="'email'"
                />
                <span
                  class="text-danger text-sm"
                  id="email-error"
                  v-show="errors.has('email')"
                  >{{ errors.first("email") }}</span
                >
              </div>
              <div v-show="participantAge < minAge">
                <vs-input
                  label="Nome completo do responsável"
                  placeholder="Ex.: Carlos Alberto"
                  v-model="form.responsible.name"
                  type="text"
                  class="w-full"
                  id="responsibleName"
                  name="responsibleName"
                  data-vv-as="'Nome do responsável'"
                  v-validate="{
                    required: true,
                    min: 5,
                    max: 255,
                    regex: /^[a-zÀ-ú]+(?:\s[a-zÀ-ú]+)+\s*$/i,
                  }"
                />
                <span
                  class="text-danger text-sm"
                  id="responsibleName-error"
                  v-show="errors.has('responsibleName')"
                  >{{ errors.first("responsibleName") }}</span
                >

                <vs-input
                  label="CPF do responsável"
                  v-model="form.responsible.cpf"
                  type="tel"
                  class="mt-3 w-full"
                  id="responsibleCpf"
                  name="responsibleCpf"
                  v-mask="'###.###.###-##'"
                  data-vv-as="'CPF do responsável'"
                  v-validate="{ required: true, cpf: true, is_not: form.cpf }"
                />
                <span
                  class="text-danger text-sm"
                  id="responsibleCpf-error"
                  v-show="errors.has('responsibleCpf')"
                  >{{ errors.first("responsibleCpf") }}</span
                >
                <vs-input
                  label="RG do responsável"
                  v-model="form.responsible.rg"
                  maxlength="14"
                  type="tel"
                  class="mt-3 w-full"
                  id="responsibleRg"
                  name="responsibleRg"
                  data-vv-as="'RG do responsável'"
                  v-validate="'required|min:7|max:14'"
                />
                <span
                  class="text-danger text-sm"
                  id="responsibleRg-error"
                  v-show="errors.has('responsibleRg')"
                  >{{ errors.first("responsibleRg") }}</span
                >

                <vs-input
                  label="Celular do responsável"
                  v-model="form.responsible.mobile"
                  type="tel"
                  class="mt-3 w-full"
                  id="responsibleMobile"
                  name="responsibleMobile"
                  v-mask="'(##) #####-####'"
                  data-vv-as="'Celular do responsável'"
                  v-validate="'required|min:15|max:15'"
                />
                <span
                  class="text-danger text-sm"
                  id="responsibleMobile-error"
                  v-show="errors.has('responsibleMobile')"
                  >{{ errors.first("responsibleMobile") }}</span
                >

                <vs-input
                  label="E-mail do responsável"
                  v-model="form.responsible.email"
                  type="email"
                  class="mt-3 w-full"
                  id="responsibleEmail"
                  name="responsibleEmail"
                  data-vv-as="'E-mail do responsável'"
                  v-validate="'email'"
                />
                <span
                  class="text-danger text-sm"
                  id="responsibleEmail-error"
                  v-show="errors.has('responsibleEmail')"
                  >{{ errors.first("responsibleEmail") }}</span
                >
              </div>
              <vs-input
                label="Nacionalidade"
                v-model="form.nationality"
                type="text"
                class="mt-3 w-full"
                id="nationality"
                name="nationality"
                data-vv-as="'Nacionalidade'"
                v-validate="{
                  required: true,
                  min: 2,
                  max: 255,
                  regex: /^[^0-9]+$/,
                }"
              />
              <span
                class="text-danger text-sm"
                id="nationality-error"
                v-show="errors.has('nationality')"
                >{{ errors.first("nationality") }}</span
              >

              <p style="margin-top: 10px; font-size: 12px">Estado civil</p>
              <select
                v-model="form.maritalStatus"
                id="maritalStatus"
                name="maritalStatus"
                @change="onMaritalChange($event)"
              >
                <option
                  :key="index"
                  :value="item.id"
                  v-for="(item, index) in maritalStatusList"
                >
                  {{ item.name }}
                </option>
              </select>
              <span
                class="text-danger text-sm"
                id="maritalStatus-error"
                v-show="maritalError"
              >
                O campo 'Estado civil' é obrigatório
              </span>

              <vs-input
                label="Profissão"
                v-model="form.occupation"
                type="text"
                class="mt-3 w-full"
                id="occupation"
                name="occupation"
                data-vv-as="'Profissão'"
                v-validate="{
                  required: true,
                  min: 2,
                  max: 255,
                  regex: /^[^0-9]+$/,
                }"
              />
              <span
                class="text-danger text-sm"
                id="occupation-error"
                v-show="errors.has('occupation')"
                >{{ errors.first("occupation") }}</span
              >

              <vs-input
                label="CEP"
                v-model="form.address.zipCode"
                type="tel"
                class="mt-5 w-full"
                id="zipCode"
                name="zipCode"
                v-mask="'#####-###'"
                data-vv-as="'CEP'"
                @blur="(e) => findCEP(e.target.value)"
                v-validate="'required|min:9|max:9'"
              />
              <span
                class="text-danger text-sm"
                id="zipCode-error"
                v-show="errors.has('zipCode')"
                >{{ errors.first("zipCode") }}</span
              >
              <span
                class="text-danger text-sm"
                id="zipCode-error"
                v-show="cepNotFound"
                >* CEP não encontrado</span
              >

              <vs-input
                label="Estado"
                v-model="form.address.state"
                type="text"
                class="mt-3 w-full"
                id="state"
                name="state"
                data-vv-as="'Estado'"
                v-validate="{
                  required: true,
                  min: 2,
                  max: 255,
                  regex: /^[^0-9]+$/,
                }"
              />
              <span
                class="text-danger text-sm"
                id="state-error"
                v-show="errors.has('state')"
                >{{ errors.first("state") }}</span
              >

              <vs-input
                label="Cidade"
                v-model="form.address.city"
                type="text"
                class="mt-3 w-full"
                id="city"
                name="city"
                data-vv-as="'Cidade'"
                v-validate="{
                  required: true,
                  min: 2,
                  max: 255,
                  regex: /^[^0-9]+$/,
                }"
              />
              <span
                class="text-danger text-sm"
                id="city-error"
                v-show="errors.has('city')"
                >{{ errors.first("city") }}</span
              >

              <vs-input
                label="Bairro"
                v-model="form.address.neighborhood"
                type="text"
                class="mt-3 w-full"
                id="neighborhood"
                name="neighborhood"
                data-vv-as="'Bairro'"
                v-validate="{
                  required: true,
                  min: 2,
                  max: 255,
                }"
              />
              <span
                class="text-danger text-sm"
                id="neighborhood-error"
                v-show="errors.has('neighborhood')"
                >{{ errors.first("neighborhood") }}</span
              >

              <vs-input
                label="Rua"
                v-model="form.address.street"
                type="text"
                class="mt-3 w-full"
                id="street"
                name="street"
                data-vv-as="'Rua'"
                v-validate="{
                  required: true,
                  min: 2,
                  max: 255,
                }"
              />
              <span
                class="text-danger text-sm"
                id="street-error"
                v-show="errors.has('street')"
                >{{ errors.first("street") }}</span
              >

              <vs-input
                label="Número"
                v-model="form.address.number"
                type="tel"
                class="mt-3 w-full"
                id="number"
                name="number"
                data-vv-as="'Número'"
                v-validate="{
                  required: true,
                  min: 1,
                  max: 50,
                }"
              />
              <span
                class="text-danger text-sm"
                id="number-error"
                v-show="errors.has('number')"
                >{{ errors.first("number") }}</span
              >

              <vs-input
                label="Complemento"
                v-model="form.address.complement"
                type="text"
                class="mt-3 w-full"
                id="complement"
                name="complement"
                data-vv-as="'Complemento'"
              />

              <vs-checkbox
                v-model="form.terms"
                name="terms"
                id="terms"
                :required="true"
                data-vv-as="'de aceite dos Termos de Uso e Política de Privacidade'"
                v-validate="{
                  required: true,
                }"
                class="mt-5"
              >
                Li e concordo com os
                <a target="_blank" :href="links.terms">Termos de Uso</a> e
                <a target="_blank" :href="links.policy"
                  >Política de Privacidade</a
                >.
              </vs-checkbox>
              <vs-row>
                <p
                  class="text-danger text-sm"
                  id="terms-error"
                  v-show="errors.has('terms')"
                >
                  {{ errors.first("terms") }}
                </p>
              </vs-row>

              <div v-show="participantAge >= minAge">
                <vs-checkbox
                  name="marketing"
                  id="marketing"
                  v-model="form.marketing"
                  class="mt-5"
                >
                  Aceito receber informações das empresas do Grupo Silvio Santos
                  e de seus parceiros comerciais.
                </vs-checkbox>
                <p
                  class="text-danger text-sm"
                  id="marketing-error"
                  v-show="errors.has('marketing')"
                >
                  {{ errors.first("marketing") }}
                </p>
              </div>
              <div>
                <p
                  class="device-status"
                  :style="
                    deviceWasValidated ? { color: 'green' } : { color: '#aaa' }
                  "
                >
                  {{
                    deviceWasValidated
                      ? "Dispositivo validado"
                      : "Dispositivo não validado"
                  }}
                </p>
              </div>

              <div class="row-navigation-2-buttons">
                <vs-button class="back-button" @click="backOnForm()"
                  ><i class="fa fa-arrow-left"></i>Voltar</vs-button
                >

                <vs-button
                  v-if="isNewUser"
                  @click="validateFormAndGoToPhotoEdit()"
                  class="next-button"
                  :style="
                    !deviceWasValidated ? { backgroundColor: 'green' } : {}
                  "
                  >{{ deviceWasValidated ? "Avançar" : "Validar e Avançar"
                  }}<i class="fa fa-circle-arrow-right"></i
                ></vs-button>
                <vs-button
                  v-if="!isNewUser && !isUpdatingParticipant"
                  @click="updateUserData()"
                  class="next-button"
                  >Atualizar</vs-button
                >
                <vs-button
                  v-if="!isNewUser && isUpdatingParticipant"
                  @click="updateUserData()"
                  class="next-button"
                >
                  <i
                    class="fas fa-circle-notch fa-spin"
                    style="color: #fff; font-size: 15px; margin-right: 10px"
                  ></i>
                  Atualizando...</vs-button
                >
              </div>
            </div>
          </tab-content>
          <tab-content :before-change="beforeTabChange3">
            <div class="participant-photo-container">
              <p>
                <b style="font-size: 18px">Envie sua foto</b> <br />
                {{
                  isNewUser
                    ? "Ela será utilizada para agilizar sua entrada no SBT!"
                    : "Atualize sua foto se ainda não enviou. Ela será utilizada para agilizar sua entrada no SBT!"
                }}
              </p>
              <vs-row vs-justify="center">
                <div
                  id="div-with-loading"
                  class="avatar-container vs-con-loading__container"
                >
                  <img class="avatar-img" :src="photoPreview" />
                </div>
              </vs-row>

              <vs-row vs-justify="center">
                <div>
                  <label for="arquivo1">
                    <span v-if="!isNewUser && isUploadingAvatar">
                      <i
                        class="fas fa-circle-notch fa-spin"
                        style="color: #fff; font-size: 15px; margin-right: 10px"
                      ></i>
                      Aguarde...
                    </span>
                    <vs-row
                      v-else
                      style="align-items: center"
                      vs-justify="center"
                    >
                      <feather-icon
                        style="margin-right: 10px"
                        icon="CameraIcon"
                        class="cursor-pointer"
                      >
                      </feather-icon>
                      Tirar Foto
                    </vs-row>
                  </label>
                  <input
                    type="file"
                    ref="file1"
                    name="file1"
                    id="arquivo1"
                    capture="camera"
                    accept="image/*"
                    @change="readFile(1)"
                  />
                </div>
              </vs-row>
              <vs-row>
                <div class="row-navigation-2-buttons">
                  <vs-button class="back-button" @click="backOnPhotoStep()"
                    ><i class="fa fa-arrow-left"></i> Voltar</vs-button
                  >
                  <vs-button
                    v-if="isNewUser && !deviceWasValidated"
                    @click="validateTokenAndCreateParticipant()"
                    :class="[
                      !isActiveStep4Button
                        ? 'next-button disabled-next-button'
                        : 'next-button',
                      form.photo ? '' : 'invisible-button',
                    ]"
                  >
                    {{ form.photo ? "Avançar" : "Pular etapa" }}
                    <i class="fa fa-circle-arrow-right"></i>
                  </vs-button>
                  <vs-button
                    v-if="isNewUser && deviceWasValidated"
                    @click="createParticipant()"
                    :class="[
                      !isActiveStep4Button
                        ? 'next-button disabled-next-button'
                        : 'next-button success-next-button',
                      form.photo ? '' : 'invisible-button',
                    ]"
                  >
                    <span v-if="isSendingNewParticipant">
                      <i
                        class="fas fa-circle-notch fa-spin"
                        style="color: #fff; font-size: 15px; margin-right: 10px"
                      ></i>
                      Aguarde...
                    </span>
                    <span v-if="!isSendingNewParticipant">
                      {{ form.photo ? "FINALIZAR INSCRIÇÃO" : "FINALIZAR" }}
                    </span>
                  </vs-button>

                  <vs-button
                    v-if="!isNewUser"
                    @click="goToAssociation()"
                    :class="
                      !isActiveStep4Button
                        ? 'next-button disabled-next-button'
                        : 'next-button'
                    "
                    >Pular etapa -<i class="fa fa-circle-arrow-right"></i
                  ></vs-button>
                </div>
              </vs-row>

              <vs-row vs-justify="center" style="margin: 50px" v-if="1 === 2">
                <wizard-button
                  @click.native="
                    () => {
                      FormWizardScope.nextTab();
                    }
                  "
                >
                </wizard-button>
              </vs-row>
            </div>
          </tab-content>

          <tab-content>
            <img
              src="@/assets/images/pages/login/sbt-caravanas-logo.png"
              alt="Portal do Auditório e Inscrições do SBT"
              class="mx-auto sbt-logo"
            />
            <div v-if="operationWasSuccessfull">
              <h2 class="wizard-title">
                Prontinho, {{ form.name || participant.name }}!
              </h2>
              <p v-if="isRemovingData" class="wizard-text">
                Seus dados foram excluídos com sucesso.
              </p>
              <p v-else-if="!isNewUser" class="wizard-text">
                Seu cadastrado agora está atualizado.
              </p>
              <p v-else class="wizard-text">
                Agora é só avisar o caravanista
                <b>{{ caravanistName }}</b> que seu cadastro foi finalizado.
              </p>
              <p
                v-if="!isRemovingData && isNewUser && participantAge < minAge"
                class="wizard-text child"
              >
                É importante que você traga a autorização impressa e assinada
                pelo responsável {{ form.responsible.name }}
                {{ form.responsible.surname }}
                <br />
                <a target="_blank" :href="links.minorResponsible"
                  >[Baixe autorização clicando aqui]</a
                >
              </p>
              <p class="wizard-text">Obrigado.</p>
            </div>
            <div v-else>
              <h2 class="wizard-title">Por favor, aguarde...</h2>
            </div>
          </tab-content>
        </form-wizard>
        <span v-if="smsCodeTmp" id="test-sms-code" class="invisible">{{
          smsCodeTmp
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import { mask } from "vue-the-mask";
import moduleParticipant from "@/store/participant/moduleParticipant";
import fullAgeTerm from "@/components/fullAgeTerm";
import underageTerm from "@/components/underageTerm";
import axios from "axios";

import moment from "moment";
import { resizeImage } from "../../utils/image";
import { notifyError, notifyErrorsFromServer } from "../../utils/notify";
import {
  goToStep0,
  goToStep1,
  goToStep2,
  goToStep3,
  goToStep4,
} from "../../utils/navigation";
import {
  mountParticipantToRequest,
  populateForm,
  subscripionFormFiels,
  subscriptionFieldsToCheck,
  subscriptionGenderList,
  subscriptionMaritalStatusList,
} from "../../utils/formHelper";
import {
  confirmSmsCodeOnServerForNewUser,
  confirmSmsCodeOnServerForParticipantId,
  createParticipanteDataOnServer,
  findCpfOnServer,
  requestSmsFromServerForNewUser,
  requestSmsFromServerForParticipantId,
  updateCaravanistList,
  updateParticipanteDataOnServer,
} from "../../utils/services";
import {
  IMAGE_ASSIGNMENT,
  POLICY_URL,
  TERMS_URL,
  UNDER_AGE_URL,
} from "../../utils/strings";
import {
  getParticipantFromLocalStorage,
  getTokenFromLocalStorage,
  storageCaravanist,
  storageNewUserToken,
  storageParticipant,
} from "../../utils/jwt";
import { validateFieldsArray, validateFormStep3 } from "../../utils/validation";

import Resume from "../pages/subscription/Step3_resume.vue";
import {
  checkIfIsVinculated,
  getMobileFromForm,
  getEmailFromForm,
  getPhotoPreview,
  isVinculatedWithAnotherCaravanist,
} from "../../utils/subscriptionFunctions";
import { sendSentryMessage } from "@/utils/sentry";
import {
  getCodeWasSentCookie,
  setCodeWasSentCookie,
  getDeviceNumberIsValidated,
  setDeviceNumberIsValidated,
  setLatestConfirmedCodeFromCookie,
  exludeDeviceNumberIsValidated,
  getCodeForNewUserWasSentCookie,
  setCodeForNewUserWasSentCookie,
  exludeCodeForNewUserWasSentCookie,
} from "../../utils/cookies";
import { analytics } from "../../main"; // Caminho relativo para o arquivo main.js
import { logEvent } from "firebase/analytics";

export default {
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    moduleParticipant,
    fullAgeTerm,
    underageTerm,
    Resume,
  },
  data() {
    return {
      cpfStepButtonText: "",
      isUploadingAvatar: false,
      isInResumeMode: false,
      isEditingData: false,
      isNewAssociation: false,
      isUpdatingParticipant: false,
      isSendingNewParticipant: false,
      isCreatingAssociation: false,
      participantData:
        getParticipantFromLocalStorage(this?.userCpfFromServer?.cpf) || null,
      isCpfOk: true,
      userCpfFromServer: null,
      associatedCaravanists: [], // lista de caravanistas já associado com o participante
      codeIsOk: false,
      deviceWasValidated: false,
      isActiveStep4Button: false,
      selectedInput: null,
      preview: require("../../assets/images/portrait/avatar.png"),
      photo: null,
      links: {
        terms: TERMS_URL,
        policy: POLICY_URL,
        minorResponsible: UNDER_AGE_URL,
        imageAssignment: IMAGE_ASSIGNMENT,
      },
      genderError: false,
      specialNeedError: false,
      maritalError: false,
      popupActivo4: false, //  imageAssignment
      createUser: false,
      confirmSMSCreate: true,
      tabIndex: 0,
      startIndex: 0, // can be used to test steps directly (default is 0)
      lastIndex: 3,
      minAge: 18,
      smsCode: [],
      smsCodeTmp: "",
      participantToken: "",
      smsCodeErrorMsg: "",
      participantMobile: "",
      participantEmail: "",
      activeSMSModal: false,
      operationWasSuccessfull: false,
      showGenderDetails: false,
      isUpdatingData: false,
      isRemovingData: false,
      validatedTabResults: { 0: true },
      FormWizardScope: {},
      cepNotFound: false,
      form: subscripionFormFiels,
      fieldsToCheck: subscriptionFieldsToCheck,
      gendersList: subscriptionGenderList,
      maritalStatusList: subscriptionMaritalStatusList,
    };
  },
  directives: { mask },
  filters: {
    formatCelphoneMasked: (value) => {
      if (!value) return "";
      return value?.replace(/(\d{2})(\d{5})(\d{4})/, "($1) # ####-$3");
    },
  },
  props: {
    caravanistUuid: { required: true },
    caravanistName: { required: true },
    isSidebarActive: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    photoPreview() {
      return getPhotoPreview(
        this.isNewUser,
        this.participantData,
        this.form,
        this.preview
      );
    },
    today() {
      return new Date()
        .toISOString()
        .substr(0, 10)
        .split("-")
        .reverse()
        .join("/");
    },
    isNewUser() {
      return !this.userCpfFromServer;
    },
    enableProgressBtn() {
      const fieldsToCheck = this.fieldsToCheck[this.tabIndex] || [];
      // skips validation if user is NOT updating their data
      if (!this.isNewUser && !this.isUpdatingProfile) {
        return true;
      }
      let hasErrors = 0;
      this.validatedTabResults[this.tabIndex] = false;
      fieldsToCheck.forEach((field) => {
        if (!this.form[field]) {
          hasErrors++;
        }
      });
      if (!hasErrors || (this.errors.items && this.errors.items.length < 2)) {
        this.validatedTabResults[this.tabIndex] = true;
      }
      return this.validatedTabResults[this.tabIndex] === true;
    },
    genderList() {
      return subscriptionGenderList;
    },
    aceptTermImage() {
      return this.form.imageAssignment;
    },
    participantCPF() {
      return this.filterNumbers(this.form.cpf);
    },
    participant() {
      return this.$store.state.participant.single;
    },
    participantAlreadyRegistered() {
      return this.$store.state.participant.exists === true;
    },
    participantAlreadyVinculated() {
      return this.$store.state.participant.isVinculated === true;
    },
    participantWasExcluded() {
      return this.$store.state.participant.wasExcluded === true;
    },
    smsCodeSent() {
      return this.$store.state.participant.smsCodeSent === true;
    },
    allowProfileUpdate() {
      return this.$store.state.participant.allowProfileUpdate === true;
    },
    isUpdatingProfile() {
      return (
        this.participantAlreadyRegistered &&
        this.participantAlreadyVinculated &&
        this.allowProfileUpdate
      );
    },
    isInputedCodeValid() {
      if (this.smsCode.length) {
        const smsCode = String(this.smsCode?.join(""));
        if (!this.validateNumber(smsCode) || smsCode.length < 4) {
          return false;
        }
      }
      return true;
    },
    participantAge() {
      return moment().diff(
        moment(this.form.birthdate, "DD/MM/YYYY"),
        "years",
        false
      );
    },
  },
  methods: {
    goToWelcome() {
      goToStep0(this.$refs, this.tabIndex);
      this.tabIndex = 0;
    },
    startFlow() {
      this.tabIndex = 1;
      goToStep1(this.$refs, this.tabIndex);
    },
    async checkCpfOnServer() {
      const isValid = await validateFieldsArray(this.errors, this.$validator, [
        "cpf",
        "birthdate",
      ]);
      if (!isValid) return;
      if (this.cpfStepButtonText && this.cpfStepButtonText.length > 0) return;

      this.setLoading(true);
      this.cpfStepButtonText = " Aguarde...";
      const cpfObj = await findCpfOnServer(
        this.$store,
        this.participantCPF,
        this.caravanistUuid
      );
      if (cpfObj) {
        cpfObj.cpf = this.participantCPF;
      }
      this.setLoading(false);
      this.cpfStepButtonText = "";
      if (cpfObj && cpfObj.cpf) {
        // CPF JA CADASTRADO !!

        if (cpfObj.state && cpfObj.state === "problem") {
          // CPF na lista de restritos. CPF NAO OK
          this.isCpfOk = false;
          return;
        } else {
          // CPF Encontrado, participante já existe
          // preencher userCpfFromServer e colocar em modo de RESUMO
          this.isCpfOk = true;
          this.userCpfFromServer = cpfObj;
          this.isInResumeMode = true;
          if (Array.isArray(cpfObj.uuid)) {
            this.associatedCaravanists = cpfObj.uuid;
          }

          const participantDataFromStorage =
            await getParticipantFromLocalStorage(cpfObj.cpf);
          //
          /* if (
            !(participantDataFromStorage && participantDataFromStorage.name)
          ) {
            const latestCode = await getLatestConfirmedCodeFromCookie();
            if (latestCode) {
              const confirmation = await confirmSmsCodeOnServerForParticipantId(
                this.$store,
                latestCode,
                this.userCpfFromServer.id
              );

              if (confirmation) {
                const refreshParticipant = confirmation.participant;
                storageParticipant(
                  refreshParticipant,
                  this.userCpfFromServer.cpf
                );
              }
            }
          } */
        }

        await this.goToNextAfterCpf();
      } else {
        this.isCpfOk = true;
        // o usuario entrou agoroa nao tem cpf cadastrado
        // deve ir para o formulario
        this.isInResumeMode = false;
        this.userCpfFromServer = null;
        this.goFromCpfToUserForm();
      }
    },

    async checkIfCodeWasAlreadySent() {
      // Após o servidor enviar SMS e email e retornar OK para o frontend
      // o frontend armazena por 30 minutos esse código
      // impedindo o usuario de gerar mais de 1 SMS
      return getCodeWasSentCookie(this.participantCPF);
    },

    // esse método só é chamado se USER Já EXISTE
    async goToNextAfterCpf() {
      const validJWT = await getTokenFromLocalStorage(this.participantCPF);
      this.token = validJWT || null;
      const hasValidJWT = !!validJWT;

      if (hasValidJWT) {
        // O usuário já possui JWT valido armazenado (participante existente)
        // não precisará validar Código/device
        // IR para o formulário
        this.cpfStepButtonText = "";
        this.codeIsOk = true;
        sendSentryMessage(
          "usuário já possuia SMS no dispositivo",
          "info",
          "sms",
          {
            cpf: this.userCpfFromServer,
            validJWT,
          }
        );
        this.goToNextAfterJWTisValid();
      } else {
        // O usuário NAO possui JWT ou Code válido, armazenado no dispositivo
        // Neste caso, precisará validar o dispositivo via Code
        //
        // Primeiramente, verificar se o código ja foi enviado via SMS e EMAIL pelo servidor
        const codeWasAlreadySent = await this.checkIfCodeWasAlreadySent();
        if (codeWasAlreadySent) {
          this.cpfStepButtonText = "";
          // Código já foi enviado. Neste caso, somente mostrar o Modal para o usuario informar o Código
          sendSentryMessage(
            "SMS não precisou ser validado - código ja enviado " +
              codeWasAlreadySent,
            "info",
            "sms"
          );
          this.toggleSMSModal(true);
          return;
        } else {
          this.cpfStepButtonText = " Enviando SMS para você...";
          // Caso o codigo não tenha sido enviado, enviar código via SMS/EMail
          // O CODIGO de verificacao ainda nao está salvo no celular
          const participantCPF = this.filterNumbers(this.form.cpf);
          let smsGenerated = null;
          // o Usuario Já existe (CPF nao existe)
          // solicitar SMS com o ID do usuário Existente
          smsGenerated = await requestSmsFromServerForParticipantId(
            this.$store,
            this.userCpfFromServer.id
          );
          this.cpfStepButtonText = "";
          if (!smsGenerated) {
            sendSentryMessage(
              "Falha ao solicitar SMS para o participante existente 🚧🚧🚧 ",
              "error",
              "sms",
              {
                cpfDataFromServer: this.userCpfFromServer,
                validJWT,
                smsGenerated,
                participantCPF,
              }
            );
          } else {
            setCodeWasSentCookie(this.participantCPF);
            sendSentryMessage(
              "SMS enviado para o participante EXISTENTE 💌💌",
              "info",
              "sms",
              { cpfData: this.userCpfFromServer }
            );
          }

          /*
            // o Usuario é novo (CPF nao existe)
            // solicitar SMS para o novo usuário, usando seu numero de telefone
            smsGenerated = await requestSmsFromServerForNewUser(
              this.$store,
              this.filterNumbers(this.form.mobile)
            );

            if (!smsGenerated) {
              sendSentryMessage(
                "Falha ao solicitar SMS para um NOVO participante 🚧🚧🚧 ",
                "error",
                "sms",
                {
                  cpfDataFromServer: this.userCpfFromServer,
                  validToken,
                  smsGenerated,
                  participantCPF,
                }
              );
            } else {
              setCodeWasSentCookie(participantCPF);
              sendSentryMessage(
                "SMS enviado para o NOVO participante 💌💌",
                "info",
                "sms",
                { participantCPF }
              );
            }
            */

          if (smsGenerated) {
            this.participantMobile = smsGenerated.mobile;
            this.smsCodeTmp = smsGenerated.code || false;
            this.participantEmail = smsGenerated.email || null;
            this.toggleSMSModal(true);
          } else {
            sendSentryMessage(
              "Usuário ficou preso na tela do CPF 🚧🚧🚧 ",
              "info",
              "cpf",
              {
                participantCPF,
              }
            );
          }
        }
      }
    },

    // GoToNext ou vai para o Formulario ou Resumo dos dados ou para Associar nova caravanista
    async goToNextAfterJWTisValid() {
      let currentCaravanistUuid;
      // o endpoint /cpf/exists retorna uma array de uuid das caravanistas associadas a um participante
      const isVinculatedWithAnother = isVinculatedWithAnotherCaravanist(
        this.caravanistUuid,
        this.associatedCaravanists
      );

      // a caravanista atual está na lista de caravanista desse participante?
      const alreadViculateWithThisCaravanist = checkIfIsVinculated(
        this.caravanistUuid,
        this.associatedCaravanists
      );
      console.log(
        "Caravanista UUID --> " + this.caravanistUuid,
        this.associatedCaravanists
      );
      console.log(
        "possui vinculo com ESTA caravanista",
        alreadViculateWithThisCaravanist
      );
      console.log(
        "possui vinculo com OUTRA caravanista",
        isVinculatedWithAnother
      );

      if (alreadViculateWithThisCaravanist) {
        // voltando com a mesma caravanista. Mostrar tela de edicao de dados
        this.isNewUser = false;
        this.isNewAssociation = false;
      } else if (isVinculatedWithAnother) {
        // NOVA ASSOCIAÇÃO
        // esse participante nao possui vinculo com a caravanista atual mas possui outra caravanista
        // 1 - Mostrar opção de ASSOCIAR A NOVA CARAVANISTA (Atual)
        // 2 - Dar opção de atualizar dados
        this.isNewUser = false;
        this.isNewAssociation = true;
      } else {
        // Nao está vinculado a caravanista atual, nem possui mais caravanistas no array
        // (Array de caravanistas aqui está vazio)
        // NOVO USER - Ir para o cadastro
        // this.isNewUser = true;
        this.isNewAssociation = false;
      }

      this.goToRefreshData();

      if (!this.isNewUser) {
        // se nao for participante novo, pegar dados desse participante do localstorage

        let participantData = await getParticipantFromLocalStorage(
          this.userCpfFromServer.cpf
        );

        if (participantData) {
          this.participantData = participantData;
        } else {
          // TODO: criar metodo que obtem dados do participante usando o ID e JWT
          const dataFromServer = null;
        }

        populateForm(this.form, this.participantData);
        currentCaravanistUuid = this.caravanistUuid;
      }
    },
    goToUserForm() {
      goToStep2(this.$refs, this.tabIndex);
      this.tabIndex = 2;
    },
    goToRefreshData() {
      this.isUpdatingData = true;
      goToStep2(this.$refs, this.tabIndex);
    },
    jumpFromDataOkToSuccess() {
      this.operationWasSuccessfull = true;
      this.isUpdatingData = true;
      goToStep4(this.$refs, this.tabIndex);
      this.tabIndex = 4;
    },
    jumpFromResumeToFinish() {
      goToStep4(this.$refs, this.tabIndex);
      this.tabIndex = 4;
    },
    jumpFromResumeToUserForm() {
      this.isInResumeMode = false;
    },
    jumpFromResumeToPhoto() {
      this.isUpdatingData = true;
      goToStep3(this.$refs, this.tabIndex);
    },
    jumpFromImageAssignmentToPhotoEdit() {
      this.popupActivo4 = false;
      //this.form.imageAssignment = true;
      // this.imageAssignment = true;
      // this.validateFormAndGoToPhotoEdit();
    },
    jumpFromExcludeToFinish() {
      this.isRemovingData = true;
      this.operationWasSuccessfull = true;
      goToStep4(this.$refs, this.tabIndex);
      this.tabIndex = 4;
    },

    clearTokenCodeAndParticipantData() {
      storageParticipant(null, this.cpfDataFromServer?.cpf);
      exludeCodeForNewUserWasSentCookie();
      exludeDeviceNumberIsValidated();
      // storageNewUserToken(null);
    },

    // NEW User - finalizou o formulario
    async validateFormAndGoToPhotoEdit() {
      if (
        this.isNewUser &&
        this.participantAge &&
        this.participantAge < 18 &&
        !this.form.imageAssignment
      ) {
        this.popupActivo4 = true;
        return;
      }

      const isValid = await validateFormStep3(
        this.errors,
        this.$validator,
        this.form,
        this.participantAge,
        this.genderError,
        this.specialNeedError,
        this.maritalError
      );
      if (!isValid) {
        notifyError(this, "Preencha todos os campos e aceite os termos.");
        return;
      }
      // para o novo usuario a validacao é feita usando CODE e mobile (nao usa JWT)
      const deviceWasValidated = getDeviceNumberIsValidated(this.form.cpf);

      this.deviceWasValidated = !!deviceWasValidated;

      if (this.isNewUser && !this.deviceWasValidated) {
        this.requestSMSForNewUserAndOpenModal();
        return;
      } else {
        this.goToPhotoEdit();
      }
    },
    goToPhotoEdit() {
      goToStep3(this.$refs, this.tabIndex);
      this.tabIndex = 3;
    },
    // metodo chamado somente para NOVO Usuario
    // vai da tela do CPF para o formulário vazio
    goFromCpfToUserForm() {
      this.isUpdatingData = true;
      this.isInResumeMode = false;
      this.participantData = null; // resetando os dados para iniciar formulario vazio
      this.form = subscripionFormFiels; // resetando os dados para iniciar formulario vazio
      goToStep2(this.$refs, this.tabIndex);
      this.tabIndex = 2;
    },
    goToAssociation() {
      goToStep4(this.$refs, this.tabIndex);
      this.tabIndex = 4;
    },
    // botao voltar na pagina de formulario/resumo
    backOnForm() {
      if (!this.isNewUser && this.isInResumeMode) {
        // Participante está na tela de resumo, ao voltar, volta para a tela de CPF
        this.startFlow();
      } else if (!this.isNewUser && !this.isInResumeMode) {
        // Participante está na tela de FORMULARIO, ao voltar, volta o modo para resumo
        this.isInResumeMode = true;
      } else {
        // é um novo usuario que está no formulario, voltar para o cpf
        this.startFlow();
      }
    },
    // botao voltar no step 4 - Edicao de Foto
    backOnPhotoStep() {
      // voltara para o formulario
      this.goToUserForm();
    },
    async validateTokenAndCreateParticipant() {
      const validJWT = await getTokenFromLocalStorage(this.participantCPF);
      if (validJWT) {
        this.createParticipant();
      } else {
        const participant = this.getFormData();
        const mobile = getMobileFromForm(participant);
        const email = getEmailFromForm(participant);
        const smsGenerated = requestSmsFromServerForNewUser(
          this.$store,
          {
            mobile: this.filterNumbers(mobile),
            email: email,
          }
        );
        if (smsGenerated) {
          this.isActiveStep4Button = true;
          this.participantMobile = smsGenerated.mobile;
          this.smsCodeTmp = smsGenerated.code || false;
          this.toggleSMSModal(true);
        }
      }
    },
    async createParticipant() {
      this.isSendingNewParticipant = true;
      const index = this.participantAge < 18 ? 3 : 2;
      const isValid = await validateFieldsArray(
        this.errors,
        this.$validator,
        subscriptionFieldsToCheck[index]
      );
      if (isValid) {
        try {
          const participant = this.getFormData();
          const res = await createParticipanteDataOnServer(
            this.$store,
            participant,
            null
          );
          const newData = { ...participant };
          newData.photo = "";

          sendSentryMessage(
            "Novo Participante criado!!✅️✅️🎉🎉",
            "info",
            "subscription",
            {
              participant: newData,
            }
          );

          this.isSendingNewParticipant = false;
          this.operationWasSuccessfull = true;
          // storageNewUserToken(null);
          this.participantToken = null;
          goToStep4(this.$refs, 3);
          updateCaravanistList(this.$socket, this.caravanistUuid);
          this.clearTokenCodeAndParticipantData();
        } catch (e) {
          this.isSendingNewParticipant = false;
          notifyErrorsFromServer(this, e);
          sendSentryMessage(
            "Falha ao criar Participante ❌❌❌",
            "error",
            "subscription",
            {
              error: e,
            }
          );
        }
      }
    },

    async requestSMSForNewUserAndOpenModal() {
      // o Usuario é novo (CPF nao existe)
      // solicitar SMS para o novo usuário

      // colocar os valores do form nas variaveis participantMobile e participantEmail
      // pois essas variaveis serao usadas no modal do SMS

      let mobileToSendMessage = this.form?.mobile;
      let emailToSendMessage = this.form?.email;

      if (this.form?.responsible) {
        if (this.form.responsible?.mobile) {
          mobileToSendMessage = this.form.responsible.mobile;
        }
        if (this.form.responsible?.email) {
          emailToSendMessage = this.form.responsible.email;
        }
      }

      this.participantMobile = mobileToSendMessage;
      this.participantEmail = emailToSendMessage;

      const already = await getCodeForNewUserWasSentCookie();
      if (already) {
        this.toggleSMSModal(true);
        return;
      }

      const smsGenerated = await requestSmsFromServerForNewUser(
        this.$store,
        {
          mobile: this.filterNumbers(mobileToSendMessage),
          email: emailToSendMessage,
        }
      );
      if (!smsGenerated) {
        sendSentryMessage(
          "Falha ao solicitar SMS para um NOVO participante 🚧🚧🚧 ",
          "error",
          "sms",
          {
            mobile: mobileToSendMessage,
            email: emailToSendMessage,
            cpf: this.form.cpf,
          }
        );
      } else {
        setCodeForNewUserWasSentCookie(this.form.cpf);
        this.toggleSMSModal(true);
      }
    },

    async updateUserData() {
      const index = this.participantAge < 18 ? 3 : 2;
      const isValid = await validateFieldsArray(
        this.errors,
        this.$validator,
        subscriptionFieldsToCheck[index]
      );
      if (isValid) {
        try {
          const participant = this.getFormData();
          if (!participant || !participant?.id) {
            participant.id = this.userCpfFromServer.id;
          }
          this.isUpdatingParticipant = true;
          const token = await getTokenFromLocalStorage(this.participantCPF);
          const res = await updateParticipanteDataOnServer(
            this.$store,
            participant,
            token
          );
          this.isUpdatingParticipant = false;
          this.participantData = res;
          this.participantData.id = participant.id;
          this.isUpdatingData = false;
          this.operationWasSuccessfull = true;
          storageParticipant(this.participantData, this.userCpfFromServer.cpf);
          this.isInResumeMode = true;
        } catch (e) {
          this.isUpdatingParticipant = false;
          this.isInResumeMode = true;
          notifyErrorsFromServer(this, e);
        }
      }
    },

    onGenderChange(event) {
      this.showGenderDetails = this.form.gender === "others";
    },
    onNeedsChange(event) {
      this.form.specialNeeds = event.target.value;
      if (event.target.value) {
        this.specialNeedError = false;
      } else {
        this.specialNeedError = true;
      }
    },
    onMaritalChange(event) {
      this.form.maritalStatus = event.target.value;
      if (event.target.value) {
        this.maritalError = false;
      } else {
        this.maritalError = true;
      }
    },

    async findCEP(cep) {
      this.cepNotFound = false;
      const response = await axios.get(
        "https://viacep.com.br/ws/" + cep + "/json/"
      );
      if (response.data.erro) {
        this.cepNotFound = true;
        return;
      }
      this.form.address.state = response.data.uf;
      this.form.address.city = response.data.localidade;
      this.form.address.neighborhood = response.data.bairro;
      this.form.address.street = response.data.logradouro;
    },
    modalConfirmTerm() {
      this.popupActivo4 = true;
    },
    toggleSMSModal(value) {
      this.activeSMSModal = value === true;
      this.inputFocus(0);
    },
    setLoading(value) {
      if (value === true) {
        this.$vs.loading({
          container: "#form",
          scale: 0.6,
        });
      } else {
        this.$vs.loading.close("#form .con-vs-loading");
      }
    },

    beforeTabChange0() {
      return new Promise((resolve, reject) => {
        resolve(true);
        this.tabIndex = 1;
      });
    },

    beforeTabChange1() {
      return new Promise((resolve, reject) => {
        this.setLoading(true);

        this.validateFields(1);

        // give the validation time to fill the errors
        setTimeout(() => {
          if (this.errors.items.length < 2) {
            const participantCPF = this.filterNumbers(this.form.cpf);

            return this.$store
              .dispatch("participant/exists", {
                cpf: participantCPF,
                uuid: this.caravanistUuid,
              })
              .then((cpfFound) => {
                if (cpfFound.state && cpfFound.state === "problem") {
                  this.isCpfOk = false;
                  notifyError(this, "Cpf encontrado");
                }
                resolve(true);
              })
              .catch((err) => {
                if (err && err.response) {
                  const { errors } = err.response.data;
                  (errors || []).forEach((error) => {
                    if (error.message) {
                      notifyError(this, error.message);
                    }
                  });
                } else {
                  notifyError(
                    this,
                    "Ocorreu um erro ao realizar seu cadastro. Por favor, tente novamente em instantes."
                  );
                }
                reject(false);
              })
              .finally(() => {
                this.setLoading(false);
                setTimeout(() => {
                  if (this.participantWasExcluded) {
                    this.smsCode = "9999".split("");
                    this.confirmSMSCode();
                  }
                }, 1000);
              });
          } else {
            this.setLoading(false);
            reject(false);
          }
        }, 0);
      });
    },
    beforeTabChange2() {
      return new Promise((resolve, reject) => {
        if (this.operationWasSuccessfull) {
          resolve(true);
          return;
        }

        if (this.form.terms !== true) {
          this.form.terms = null;
          setTimeout(() => {
            this.validateFields(2);
            reject(false);
          }, 250);
          return;
        }

        if (this.form.imageAssignment !== true) {
          this.modalConfirmTerm();
          this.form.imageAssignment = null;
          setTimeout(() => {
            this.validateFields(2);
            reject(false);
          }, 250);
          return;
        }

        this.validateFields(2);

        // give the validation time to fill the errors
        setTimeout(() => {
          if (this.errors.items.length < 2) {
            resolve(true);
          } else {
            reject(false);
          }
        }, 150);
      });
    },
    beforeTabChange3() {
      return new Promise((resolve, reject) => {
        resolve(true);
        this.tabIndex = 3;
      });
    },
    goToFinishAfterAssocitation() {
      this.operationWasSuccessfull = true;
      goToStep4(this.$refs, this.tabIndex);
    },

    createAssociation() {
      const data = {
        caravanist: { uuid: this.caravanistUuid },
        id: this.participant.id,
      };

      // skips caravanist x participant vinculation request
      if (this.participantAlreadyVinculated) {
        this.goToFinishAfterAssocitation();
        return;
      }

      this.isCreatingAssociation = true;
      this.setLoading(true);

      return this.$store
        .dispatch("participant/associate", data)
        .then((resp) => {
          if ([false, false].includes(resp) || resp.data) {
            if (this.$socket && this.$socket?.readyState === 1) {
              this.$socket.sendObj({
                uuid: this.caravanistUuid,
                action: "participantsListUpdated",
              });
            }
            if (this.isNewAssociation && !this.isNewUser) {
              // IsNewAssociation é marcado como true quando a caravanista atual nao está no array de caravanistas do participante
              // O IsNewUser é marcado com false caso exista outra caravanista alem da caravanista atual
              // ou seja, o participante fez associacao com a caravanista atual, mas..
              // ja estava cadastrado com outra
              // entao o participante pode atualizar seus dados

              // colocar a nova caravanista no array de caravanistas e salvar
              const currentCaravanists = this.associatedCaravanists;
              currentCaravanists.push(this.caravanistUuid);
              this.associatedCaravanists = currentCaravanists;
              // isso fara voltar para a tela de Resumo após criar a associação
              this.isInResumeMode = true;
              this.isNewAssociation = false;

              this.$vs.notify({
                text:
                  "Você foi associada com a caravanista " +
                  this.caravanistName +
                  " com sucesso!",
                color: "success",
                iconPack: "feather",
                icon: "check-circle",
                time: 5000,
                position: "bottom-left",
              });

              sendSentryMessage(
                "Particiapante associado a uma NOVA caravanista com sucesso ✅",
                "info",
                "inscription",
                {
                  cpf: this.userCpfFromServer,
                  caravanistUuid: this.caravanistUuid,
                  currentCaravanists,
                }
              );

              this.goToNextAfterJWTisValid();
            } else {
              this.goToFinishAfterAssocitation();
            }
          } else {
            sendSentryMessage(
              "Falha ao associar a NOVA caravanista ❌",
              "error",
              "inscription",
              {
                caravanistUuid: this.caravanistUuid,
                currentCaravanists,
              }
            );
            this.$vs.notify({
              text: "Ocorreu um erro ao associar à Caravanista. Por favor, tente novamente mais tarde.",
              color: "danger",
              iconPack: "feather",
              icon: "icon-alert-circle",
              time: 10000,
              position: "bottom-left",
            });
          }
        })
        .catch((err) => {
          sendSentryMessage(
            "ERRO vindo do servidor ao associar a NOVA caravanista ❌",
            "error",
            "inscription",
            {
              caravanistUuid: this.caravanistUuid,
              currentCaravanists,
              err,
            }
          );
          if (err && err.response) {
            const { errors } = err.response.data;
            (errors || []).forEach((error) => {
              if (error.message) {
                this.$vs.notify({
                  text: error.message,
                  color: "danger",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  time: 10000,
                  position: "bottom-left",
                });
              }
            });
          }
        })
        .finally(() => {
          this.isCreatingAssociation = false;
          this.setLoading(false);
        });
    },
    validateNumber(number) {
      return /\d/.test(String(number));
    },
    setInputIndex(index) {
      this.inputIndex = index || 0;
    },
    validateInput($event) {
      if (this.validateNumber(String.fromCharCode($event.charCode))) {
        this.inputFocus(this.inputIndex + 1);
        return true;
      } else if (
        ["Enter", "enter"].includes($event.key) &&
        this.isInputedCodeValid
      ) {
        this.confirmSMSCode();
      }

      $event.preventDefault();
    },
    returToInput($event) {
      setTimeout(() => {
        if ($event.keyCode === 8) {
          const nextIndex = this.inputIndex - 1;
          this.inputFocus(nextIndex, true);
        }
      }, 15);
    },
    handlePasteValue(evt) {
      let pastedCode = String(
        (evt.clipboardData || window.clipboardData).getData("text")
      );
      if (
        this.validateNumber(String(pastedCode).trim()) &&
        pastedCode.length === 4
      ) {
        this.smsCode = pastedCode.split("");
      }
    },
    inputFocus(inputIndex) {
      if ([0, 1, 2, 3].includes(+inputIndex)) {
        setTimeout(() => {
          try {
            const inputRef = "smsInput" + String(inputIndex);
            if (this.$refs[inputRef]) {
              this.$refs[inputRef][0].focusInput();
            }
          } catch (error) {}
        }, 15);
      }
    },
    async sendSMSCodeAndConfirm() {
      const code = String(this.smsCode ? this.smsCode?.join("") : "");
      this.smsCodeErrorMsg = "";
      if (!this.validateNumber(code) || code.length < 4) {
        this.toggleSMSModal(true);
        this.smsCodeErrorMsg =
          "O código deve consistir de 4 números: Ex.: 7854";
        return;
      }
      this.setLoading(true);
      let confirmation = null;

      if (this.isNewUser) {
        const participant = this.getFormData();
        const mobile = getMobileFromForm(participant);
        confirmation = await confirmSmsCodeOnServerForNewUser(
          this.$store,
          this.smsCode,
          mobile
        );
      } else {
        confirmation = await confirmSmsCodeOnServerForParticipantId(
          this.$store,
          this.smsCode,
          this.userCpfFromServer.id
        );
      }
      this.setLoading(false);

      if (confirmation && (confirmation.token || confirmation.status)) {
        sendSentryMessage("SMS confirmado com sucesso! ✅✅✅", "info", "sms", {
          cpf: this.userCpfFromServer,
          sms: this.smsCode,
        });

        if (this.isNewUser) {
          // NOVO Usuario confirmou via status
          this.deviceWasValidated = true;
          setDeviceNumberIsValidated(this.form.cpf);
        } else {
          setLatestConfirmedCodeFromCookie(this.smsCode);
          if (confirmation.token) {
            this.participantToken = confirmation.token;
            storageNewUserToken(confirmation.token, this.form.cpf);
          }

          this.codeIsOk = true;

          storageParticipant(
            confirmation.participant,
            this.userCpfFromServer.cpf
          );

          if (this.caravanistUuid && confirmation.participant) {
            storageCaravanist(confirmation.participant, this.caravanistUuid);
          }

          setTimeout(() => {
            this.toggleSMSModal(false);
            if (!this.isNewUser) {
              this.goToNextAfterJWTisValid();
            }
          }, 300);
        }
      } else {
        this.toggleSMSModal(true);

        notifyError(
          this,
          "O Código SMS informado não está correto, ou está expirado!"
        );
      }
    },

    askRemoveParticipant() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Remover dados do SBT Caravanas`,
        text: `Deseja remover todos os seus dados do SBT Caravanas?`,
        acceptText: "Sim",
        cancelText: "Cancelar",
        accept: () => {
          this.setLoading(true);
          this.isRemovingData = true;
          this.removeParticipant();
        },
      });
    },
    async removeParticipant() {
      const tk = await getTokenFromLocalStorage(thi.participantCPF);

      console.log("remove", tk);
      this.$store
        .dispatch("participant/removeParticipantData", {
          token: tk,
        })
        .catch((err) => {
          notifyErrorsFromServer(this, err);
        })
        .then(() => {
          storageNewUserToken(null);
          this.setLoading(false);
          this.skipValidations = true;
          this.operationWasSuccessfull = true;
          this.$refs.formWizard.activateAll();
          this.jumpFromExcludeToFinish();
        })
        .finally(() => {
          this.setLoading(false);
        });
    },
    clearValidations() {
      this.errors.clear();
      this.errors.add({});
    },
    formatDate(value) {
      return value
        ? value?.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1")
        : value;
    },
    formatDate2(value) {
      return value
        ? value?.replace(/(\d{4})\-(\d{2})\-(\d{2})/, "$3/$2/$1")
        : value;
    },
    toggleGenderDetails() {
      this.showGenderDetails = !this.showGenderDetails;
    },
    filterNumbers(value) {
      return value ? value?.replace(/[^\d]/g, "") : value;
    },
    filterGender(value) {
      return value;
    },
    switchGender(value) {
      return value;
    },
    getFormData() {
      return mountParticipantToRequest(
        this.form,
        !this.isNewUser, // isUpdatingData
        this.participantAge,
        this.caravanistUuid
      );
    },
    handlePageChanges(prevIndex, nextIndex) {
      this.tabIndex = nextIndex;
      return;
    },
    async updateAvatar() {
      const token = await getTokenFromLocalStorage(this.participantCPF);
      this.isUploadingAvatar = true;
      this.$store
        .dispatch("participant/updatePhoto", {
          photo: this.photo,
          token: this.participantToken || token,
        })
        .then((resp) => {
          sendSentryMessage(
            "📷 FOTO - enviada ao server com sucesso! ✅",
            "info",
            "photo",
            {
              res: resp.data,
            }
          );
          if (!this.isNewUser) {
            const participant = getParticipantFromLocalStorage(
              this.userCpfFromServer.cpf
            );
            participant.photo = resp.data.url;
            this.participantData.photo = participant.photo;
            storageParticipant(participant, this.userCpfFromServer.cpf);
          }
        })
        .catch((e) => {
          sendSentryMessage(
            "📷 FOTO - Falha ao atualizar no servidor ❌❌❌",
            "error",
            "photo",
            {
              error: e,
            }
          );
        })
        .finally(() => {
          this.isUploadingAvatar = false;
        });
    },
    readFile(index) {
      let ref = null;
      switch (index) {
        case 0:
          ref = this.$refs.file0.files[0];
          break;
        case 1:
          ref = this.$refs.file1.files[0];
          break;
        case 2:
          ref = this.$refs.file2.files[0];
          break;
      }
      this.selectedInput = ref;

      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result) {
          resizeImage(reader.result, 600, null, "dsadasd.jpg")
            .then((res) => {
              this.preview = res;
              this.photo = res;
              this.form.photo = res;
              this.isActiveStep4Button = true;
              if (!this.isNewUser) {
                this.updateAvatar();
              }
            })
            .catch((e) => {
              sendSentryMessage(
                "📷 FOTO - Falha ao redimensionar ❌",
                "error",
                "photo",
                {
                  error: e,
                }
              );
            });
        }
      };
      reader.onerror = (e) => {
        sendSentryMessage("📷 FOTO - Falha ao carregar ❌", "error", "photo", {
          error: e,
        });
      };

      reader.readAsDataURL(this.selectedInput);
    },
  },
  created() {
    if (!moduleParticipant.isRegistered) {
      this.$store.registerModule("participant", moduleParticipant);
      moduleParticipant.isRegistered = true;
    }
  },
  mounted() {
    // resets the participant state
    if (moduleParticipant.isRegistered) {
      try {
        logEvent(analytics, "caravanista_invite", {
          name: this.caravanistName,
        });
        console.log("Evento enviado para o GA: caravanista_open", {
          name: this.caravanistName,
        });
      } catch (e) {
        console.log("erro ao lancar para o GA", e);
      }

      this.$store.dispatch("participant/reset").then((resp) => {});
    }
  },
};
</script>

<style lang="scss">
.invisible-button {
  opacity: 0.001 !important;
}
.device-status {
  width: 100%;
  text-align: center;
  font-size: 13px;
  margin-top: 16px;
}
.new-association-container {
  padding: 20px 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.container-remove-part {
  align-items: center;
}

.container-remove-part span {
  color: rgb(181, 66, 66);
  padding: 10px;
  margin: 10px;
  cursor: pointer;
}

.container-remove-part span:hover {
  background: #fff;
}

.container-remove-part hr {
  border: 1px solid #ddd;
  border-radius: 16px;
  margin: 4px 0 16px 0;
}
.row-navigation-2-buttons {
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 16px;
  padding: 10px 0;
}
.back-button {
  border: 2px solid #aaa;
  background-color: #fff !important;
  color: #aaa;
  border-radius: 24px;
  font-weight: bold;
  font-size: 13px;
}
.back-button i {
  margin-left: -12px;
  margin-right: 5px;
}
.next-button {
  font-weight: bold;
  border-radius: 24px;
  font-size: 13px;
}
.next-button i {
  margin-left: 4px;
}
.disabled-next-button {
  opacity: 0.4;
}
.success-next-button {
  background: green !important;
}

.row-navigation-1-button {
  display: flex;
  justify-content: center;
}
.avatar-container {
  width: 250px;
  height: 250px;
  margin: 20px auto 0 auto;
}
.avatar-img {
  width: 250px;
  height: 250px;
  background: #eee;
  object-fit: cover;
  border-radius: 4px;
}

.participant-photo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
}
.participant-photo-container {
  h1 {
    margin-bottom: 25px;
  }
  p {
    font-size: 15px;
    text-align: center;
  }
  input[type="file"] {
    display: none;
  }
  label {
    padding: 10px;
    width: 250px;
    border-radius: 4px;
    background-color: #333;
    color: #fff;
    font-size: 18px;
    text-transform: uppercase;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}

.image-girl-container {
  display: flex;
  justify-content: center;
}
.image-adult-container {
  margin-top: 40px;
  margin-bottom: 6px;
  background: rgb(255, 254, 245);
  padding: 6px;
  display: flex;
  justify-content: center;
}
.image-adult-man {
  width: 80px;
  object-fit: contain;
}
.image-adult-woman {
  width: 80px;
  object-fit: contain;
}

#sms-modal {
  .sms-number-holder {
    margin: 0 auto;
    input {
      text-align: center;
    }
  }
  footer {
    button:first-of-type {
      margin-right: auto;
    }
  }
}
#participant-form {
  #specialNeed {
    margin-bottom: 5px;
  }
  .sbt-logo {
    display: table;
    max-width: 70px;
    max-width: 5em;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .wizard-header {
    padding: 0 0 5px 0;
  }
  .wizard-finished {
    .wizard-nav,
    .wizard-progress-with-circle {
      visibility: hidden;
    }
    .sbt-logo {
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }
  .no-padding {
    .vue-form-wizard {
      padding: 0;
    }
  }
  .wizard-title,
  .wizard-text {
    text-align: center;
  }

  p.child {
    font-style: italic;
  }

  .wizard-text,
  .wizard-title {
    + .wizard-text {
      margin-top: 1em;
    }
  }

  .con-slot-label a {
    position: relative;
    z-index: 201;
  }
  .vs-con-textarea {
    background-color: #fff;
  }
  .vue-form-wizard {
    .wizard-tab-content {
      padding-top: 10px;
    }
  }
  .con-slot-label {
    width: calc(100% - 15px);
  }
  .vs-checkbox {
    margin-right: 10px;
  }
  .wizard-card-footer {
    margin-top: 1.25rem;
  }
}
@media (min-width: 540px) {
  #sms-modal {
    .sms-number-holder {
      max-width: 60%;
    }
  }
  #participant-form {
    > div:first-child {
      max-width: 460px;
    }
  }
}
@media (max-width: 540px) {
  #sms-modal {
    .sms-number-holder {
      max-width: 85%;
    }
  }
  #participant-form {
    .wizard-card-footer {
      display: table;
      width: 100%;
      margin-top: 1.25rem;
      margin-bottom: 1.25rem;

      > div {
        max-width: 48%;
        margin: 0;
        display: table;
        float: left;

        &.wizard-footer-right {
          float: right;
        }

        button {
          margin: 0;
          min-width: 120px;
        }
      }
    }
  }
}

@media (max-width: 320px) {
  #participant-form {
    .wizard-step-2 {
      .wizard-card-footer {
        .wizard-footer-left,
        .wizard-footer-right {
          max-width: 100%;
          width: 100%;
        }
        .wizard-footer-right {
          button {
            margin-top: 1em;
          }
        }
      }
    }
  }
}
</style>
